import{jsx as e}from"react/jsx-runtime";import r from"../../components/BaseTriggerQueryBuilderNode.js";const t=t=>e(r,Object.assign({cacheKey:"IG_TRIGGER",propertyAddBtnText:"Add condition"},t));export{t as default};
